import React from 'react'
import { connect } from 'react-redux'
import ParcelItem from './ParcelItem'
import ProjectItem from './ProjectItem'
import { addProject, deselectParcels, moveItem, addToProject } from '../../actions/parcels'
import IconFolderAdd from '../../../img/icon-folder-add.svg'
import IconRemoveCircle from '../../../img/icon-remove-circle.svg'
import Checkbox from '../Checkbox'

class SelectionOrganizer extends React.Component {
    static getDerivedStateFromProps({ items }, { checkedItems }) {
        /* Flatten items, ordered by hierarchy
         *  E.g., [parent1, parent1_child1, parent1_child2, parent2, parent2_child1, ...]
         */
        const orderedItems = items
            .filter(item => item.parent === null)
            .reduce((acc, item) => {
                acc.push(item)
                if (item.type === 'project') {
                    acc = acc.concat(items.filter(i => i.parent === item.id))
                }
                return acc
            }, [])

        return {
            items: orderedItems,
            checkedItems: items.map(item => item.apn || item.id).filter(apnOrId => checkedItems.includes(apnOrId))
        }
    }

    constructor(props) {
        super(props)

        this.state = { checkedItems: [], expanded: [], isFocused: false }
    }

    onExpand = project => {
        const { expanded } = this.state
        const isExpanded = expanded.includes(project)
        this.setState({
            expanded: isExpanded ? expanded.filter(id => id !== project) : [...expanded, project]
        })
    }

    handleClick = () => {
        const { items, checkedItems } = this.state
        const allChecked = items.every(item => checkedItems.includes(item.apn || item.id))
        this.setState({
            checkedItems: allChecked ? [] : [...items.map(item => item.apn || item.id)]
        })
    }

    render() {
        const { onDeselectParcels, onCreateProject, onMoveItem, onAddToProject } = this.props
        const { items, checkedItems, expanded, isFocused } = this.state
        const allChecked = items.every(item => checkedItems.includes(item.apn || item.id))

        return (
            <div className="selection-organizer">
                <div className="buttons">
                    <button
                        className="button is-accent is-small"
                        onClick={() => {
                            onCreateProject(checkedItems)
                            this.setState({ checkedItems: [] })
                        }}
                    >
                        <span className="svg-icon icon-18">
                            <IconFolderAdd />
                        </span>{' '}
                        Add Project
                    </button>
                    <div className="spacer" />
                    <button
                        className="button is-danger is-small"
                        disabled={checkedItems.length < 1}
                        onClick={() => onDeselectParcels(checkedItems)}
                    >
                        <span className="svg-icon icon-18">
                            <IconRemoveCircle />
                        </span>{' '}
                        Remove Selected
                    </button>
                </div>
                <table className="table parcels">
                    <thead>
                        {items.length < 1 && (
                            <tr className="no-parcels">
                                <td>No parcels selected</td>
                            </tr>
                        )}
                        {items.length > 0 && (
                            <tr>
                                <th>
                                    <Checkbox
                                        checked={allChecked}
                                        additionalClasses=""
                                        onClick={this.handleClick}
                                        aria-label="Checkbox to select all parcels"
                                    />
                                </th>
                                <th>APN</th>
                                <th>Address</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {items.map(item => {
                            const checked = checkedItems.includes(item.apn || item.id)
                            const isExpanded = expanded.includes(item.id)
                            const onCheck = () =>
                                this.setState({
                                    checkedItems: checked
                                        ? checkedItems.filter(apnOrId => apnOrId !== (item.apn || item.id))
                                        : [...checkedItems, item.apn || item.id]
                                })

                            if (item.type === 'project') {
                                return (
                                    <ProjectItem
                                        checked={checked}
                                        expanded={isExpanded}
                                        project={item}
                                        items={items.filter(i => i.parent === item.id)}
                                        onCheck={onCheck}
                                        onExpand={this.onExpand}
                                        onMoveItem={onMoveItem}
                                        onAddToProject={onAddToProject}
                                        key={item.id}
                                    />
                                )
                            }
                            if (item.parent === null || expanded.includes(item.parent)) {
                                return (
                                    <ParcelItem
                                        checked={checked}
                                        parcel={item}
                                        onCheck={onCheck}
                                        onMoveItem={onMoveItem}
                                        key={item.apn}
                                    />
                                )
                            }

                            return null
                        })}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default connect(
    ({ parcels: { items } }) => ({ items }),
    dispatch => ({
        onDeselectParcels: apns => dispatch(deselectParcels(apns)),
        onCreateProject: parcels => dispatch(addProject(parcels)),
        onMoveItem: (item, target, anchor) => dispatch(moveItem(item, target, anchor)),
        onAddToProject: (parcel, project) => dispatch(addToProject(parcel, project))
    })
)(SelectionOrganizer)
